import React, {useState} from 'react';
import {Modal} from 'react-bootstrap';
import {useDispatch} from 'react-redux';
import {assets} from '../../../../../utils/assetsSrc';
import Button from '../../../../../components/form/button/button';
import {importRiskAssessment} from '../../../../../redux/risk-assessment-core/riskAssessmentCoreSlice';
import './importRiskAssessment.scss';
import {toast} from 'react-toastify';

export default function ImportRiskAssessment({
  show,
  setShow,
  productId,
  machineId,
  onImportSuccess,
}) {
  const dispatch = useDispatch();
  const [selectedFile, setSelectedFile] = useState(null);
  const [isImporting, setIsImporting] = useState(false);

  const handleFileSelect = (event) => {
    const file = event.target.files[0];
    if (file) {
      // Validate file type
      if (
        file.type !==
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' &&
        !file.name.endsWith('.xlsx')
      ) {
        alert('Please select a valid Excel file (.xlsx)');
        return;
      }
      setSelectedFile(file);
    }
  };

  const handleImport = () => {
    if (!selectedFile) {
      toast.error('Please select an Excel file to import');
      return;
    }

    if (!productId) {
      toast.error('Product ID is required');
      return;
    }

    setIsImporting(true);
    dispatch(
      importRiskAssessment({
        file: selectedFile,
        productId: productId,
        machineId: machineId,
        callback: (response) => {
          setIsImporting(false);
          if (response && response.success) {
            setShow(false);
            setSelectedFile(null);
            if (onImportSuccess) {
              onImportSuccess(response);
            }
          }
          // Error is already handled by Redux slice toast
        },
      }),
    );
    
  };

  const handleClose = () => {
    if (!isImporting) {
      setShow(false);
      setSelectedFile(null);
    }
  };

  return (
    <Modal
      show={show}
      onHide={handleClose}
      aria-labelledby="import-risk-assessment"
      centered
      className="import-risk-assessment-modal">
      <Modal.Body className="p-5 px-5 text-center">
        <div className="header">
          <p className="label mt-3 mb-4">Import Risk Assessment</p>
          <img
            onClick={handleClose}
            src={assets.closeIcon}
            style={{cursor: isImporting ? 'not-allowed' : 'pointer'}}
          />
        </div>
        <div className="import-content">
          <p className="help-text">
            Select an Excel file (.xlsx) that was previously exported from
            another Risk Assessment. The import will copy all data to this
            model.
          </p>
          <div className="file-input-wrapper">
            <input
              type="file"
              id="file-input"
              accept=".xlsx,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
              onChange={handleFileSelect}
              disabled={isImporting}
              style={{display: 'none'}}
            />
            <label
            style={{maxWidth:"100%"}}
              htmlFor="file-input"
              className={`file-input-label ${isImporting ? 'disabled' : ''}`}>
              <img src={assets.uploadIcon} />
              <span  style={{maxWidth:"100%",overflow:"hidden"}}>
                {selectedFile ? selectedFile.name : 'Choose Excel File'}
              </span>
            </label>
          </div>
          {selectedFile && (
            <div className="file-info">
              <p style={{maxWidth:"100%",overflow:"hidden"}}>
                <strong>File:</strong> {selectedFile.name}
              </p>
              <p>
                <strong>Size:</strong> {(selectedFile.size / 1024).toFixed(2)} KB
              </p>
            </div>
          )}
          <div className="import-actions">
            <Button
              variant="secondary-button"
              clickHandler={handleClose}
              disabled={isImporting}>
              Cancel
            </Button>
            <Button
              variant="submit-button"
              clickHandler={handleImport}
              disabled={!selectedFile || isImporting}>
              {isImporting ? 'Importing...' : 'Import'}
            </Button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
}

